import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processContact = (store, item) => {
    if (item === undefined) return

    if (item.proposals) {
        _.each(item.proposals, proposal => store.dispatch('processProposal', proposal))
        delete item.proposals
    }

    if (item.tasks) {
        _.each(item.tasks, task => store.dispatch('processTask', task))
        delete item.tasks
    }

    if (item.projects) {
        _.each(item.projects, project => {
            store.dispatch('processProject', project)
        })

        delete item.projects
    }

    if (!item.pivot) {
        item.pivot = {role: ''}
    }

    store.commit(mutations.ADD_OR_UPDATE_CONTACT, item)
}

export const fetchContacts = async (store, params) => {
    return await axios.get(`/api/contacts`, {params})
        .then(res => {
            _.each(res.data.data, item => processContact(store, item))
            return res
        })
}

export const fetchContactById = (store, id) => {
    return axios.get(`/api/contacts/${id}`).then(response => {
        processContact(store, response.data.data)
        return response
    })
}

export const fetchDuplicatedContacts = (store, params) => {
    return axios.get(`/api/contacts/get-duplicated`, { params })
}

export const createContact = (store, item) => {
    return axios.post(`/api/contacts`, item)
        .then(res => {
            processContact(store, res.data.data)
            return res
        })
}

export const mergeDuplicatedContacts = (store, items) => {
    return axios.post(`/api/contacts/merge-duplicated`, { items })
}

export const updateContact = (store, item) => {
    return axios.patch(`/api/contacts/${item.id}`, item)
        .then(res => {
            processContact(store, res.data.data)
            return res
        })
}

export const partialUpdateContact = (store, item) => {
    return axios.patch(`/api/contacts/${item.id}/partial`, item)
        .then(res => {
            processContact(store, res.data.data)
            return res
        })
}

export const createOrUpdateContact = (store, item) => {
    return item.id ?
        updateContact(store, item) :
        createContact(store, item)
}

export const removeContact = (store, item) => {
    return axios.delete(`/api/contacts/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_CONTACT, item)
            return res
        })
}
